import type { FaireProductEntity } from "../../entity_types/product";

export const casa_blanca_2: FaireProductEntity = {
  token: "casa-blanca-2",
  type: "product",
  name: "Woven Throw Blanket",
  brandName: "Casa Blanca",
  imageUrl:
    "https://cdn.faire.com/fastly/92d772461b621d46b78bd7b902229ec5ea327f5abc53ba459e2b6a406e3ae1ea.jpeg?dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 45,
  msrpDollars: 68,
  freeShipping: true,
  description: "",
  categoryTokens: [],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
